import {Component} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'instructions-dialog',
    templateUrl: 'instructions.dialog.html',
})
export class InstructionsDialog {
    constructor(public translate: TranslateService){}
}
